import { Box, BoxProps } from '@mui/material';
import { styled } from '@mui/material/styles';

const HolographicCard = styled(Box)<BoxProps>(({ theme }) => ({
  position: 'relative',
  background: 'rgba(26, 26, 46, 0.6)',
  backdropFilter: 'blur(5px)',
  borderRadius: theme.spacing(2),
  border: '1px solid rgba(138, 43, 226, 0.2)',
  padding: theme.spacing(3),
  transition: 'all 0.3s ease',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '-50%',
    left: '-50%',
    width: '200%',
    height: '200%',
    background: 'linear-gradient(0deg, transparent, transparent 30%, rgba(0, 255, 255, 0.3))',
    transform: 'rotate(-45deg)',
    transition: 'all 0.5s ease',
    opacity: 0,
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: '2px',
    background: 'linear-gradient(90deg, #003366, #00CC99, #8A2BE2, #FF6F00)',
    backgroundSize: '300% 100%',
    animation: 'gradient 6s linear infinite',
  },
  '&:hover': {
    background: 'rgba(26, 26, 46, 0.8)',
    transform: 'scale(1.02)',
    boxShadow: '0 0 20px rgba(138, 43, 226, 0.3)',
    '&::before': {
      opacity: 1,
      transform: 'rotate(-45deg) translateY(100%)',
    },
  }
}));

export default HolographicCard; 